import { useGraphQLQuery } from '@betterment/graphql';

import { DateRangeOption } from '../../../../../../graphql/schema';
import { DirectTradingAccountSecurityPricePerformanceDocument } from '../graphql/directTradingAccountSecurityPricePerformance.generated';

export const useDirectTradingAccountSecurityPricePerformance = (
  accountId: string,
  securityId: string,
  currentDate: Date,
  dateRangeOption?: DateRangeOption
) => {
  const { data, loading, previousData } = useGraphQLQuery(DirectTradingAccountSecurityPricePerformanceDocument, {
    variables: { accountId, securityId, dateRangeOption, currentDate },
    fetchPolicy: 'cache-and-network',
  });

  return { data, loading, previousData };
};
